import React from "react";
import FadeIn from "react-fade-in";

// COMPONENTS
import walnutsImg from "assets/walnuts.jpg";
import chiaImg from "assets/chia.jpg";
import spirulinaImg from "assets/spirulina.jpg";
import almondsImg from "assets/almonds.jpg";
import flaxImg from "assets/flax.jpg";
import Title from "components/layout/Title";
import Nav from "components/Nav";
import SubNavLink from "../components/SubNavLink";
import Item from "../components/Item";
import Intro from "../components/layout/Intro";

import {
    colorWalnuts,
    colorChia,
    colorSpirulina,
    colorAlmonds,
    colorFlax,
} from "sass/partials/_variables.scss";

const Protein = () => {
    return (
        <FadeIn>
            <Nav protein={true} />
            <main>
                <article className="page">
                    <Title
                        bg="https://upload.wikimedia.org/wikipedia/commons/e/e7/DNA_simple.svg"
                        bgSize="50%"
                        bgRepeat="no-repeat"
                        bgPos="center -300%"
                    >
                        Protein
                    </Title>
                    <div>
                        <Intro
                            title="So you might ask:"
                            subtitle="Why do we need them?"
                            body="
                            Protein is an important component of every cell in
                            the body. ... Your body uses protein to build and
                            repair tissues. You also use protein to make
                            enzymes, hormones, and other body chemicals. Protein
                            is an important building block of bones, muscles,
                            cartilage, skin, and blood."
                        />

                        <nav className="subnav subnav-list">
                            <SubNavLink
                                text="Walnuts"
                                shortName="walnuts"
                                color={colorWalnuts}
                            />
                            <SubNavLink
                                text="Chia seeds"
                                shortName="chia"
                                color={colorChia}
                            />
                            <SubNavLink
                                text="Spirulina"
                                shortName="spirulina"
                                color={colorSpirulina}
                            />
                            <SubNavLink
                                text="Almonds"
                                shortName="almonds"
                                color={colorAlmonds}
                            />
                            <SubNavLink
                                text="Flax seeds"
                                shortName="flax"
                                color={colorFlax}
                            />
                        </nav>
                    </div>
                    <Item
                        title="Walnuts"
                        subtitle="100g"
                        shortName="walnuts"
                        color={colorWalnuts}
                        img={walnutsImg}
                        data={[
                            { name: "Kcal", stat: "654" },
                            { name: "Protein", stat: "15 g" },
                            { name: "Aminoscore", stat: "58" },
                        ]}
                    />

                    <Item
                        title="Chia"
                        subtitle="100g"
                        shortName="chia"
                        color={colorChia}
                        img={chiaImg}
                        data={[
                            { name: "Kcal", stat: "442" },
                            { name: "Protein", stat: "16,5 g" },
                            { name: "Aminoscore", stat: "115" },
                        ]}
                    />

                    <Item
                        title="Spirulina"
                        subtitle="100g"
                        shortName="spirulina"
                        color={colorSpirulina}
                        img={spirulinaImg}
                        data={[
                            { name: "Kcal", stat: "290" },
                            { name: "Protein", stat: "57,5 g" },
                            { name: "Aminoscore", stat: "103" },
                        ]}
                    />

                    <Item
                        title="Almonds"
                        subtitle="100g"
                        shortName="almonds"
                        color={colorAlmonds}
                        img={almondsImg}
                        data={[
                            { name: "Kcal", stat: "575" },
                            { name: "Protein", stat: "15 g" },
                            { name: "Aminoscore", stat: "54" },
                        ]}
                    />

                    <Item
                        title="Flax"
                        subtitle="100g"
                        shortName="flax"
                        color={colorFlax}
                        img={flaxImg}
                        data={[
                            { name: "Kcal", stat: "512" },
                            { name: "Protein", stat: "18,3 g" },
                            { name: "Aminoscore", stat: "118" },
                        ]}
                    />
                </article>
            </main>
        </FadeIn>
    );
};

export default Protein;
